import Cookies from 'js-cookie';

export default function map() {

      const google = window.google;

      var latitude = $('#map').attr('data-latitude');
      var longitude = $('#map').attr('data-longitude');

      var point = new google.maps.LatLng(latitude, longitude);

      function initMap() {
        var mapOptions = {
          mapTypeControl: false,
          streetViewControl: false,
          scrollwheel: false,
          zoom: 17,
          center: point,
          styles: [
              {
                  'featureType': 'all',
                  'elementType': 'labels.text.fill',
                  'stylers': [
                      {
                          'saturation': 36,
                      },
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 40,
                      },
                  ],
              },
              {
                  'featureType': 'all',
                  'elementType': 'labels.text.stroke',
                  'stylers': [
                      {
                          'visibility': 'on',
                      },
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 16,
                      },
                  ],
              },
              {
                  'featureType': 'all',
                  'elementType': 'labels.icon',
                  'stylers': [
                      {
                          'visibility': 'off',
                      },
                  ],
              },
              {
                  'featureType': 'administrative',
                  'elementType': 'geometry.fill',
                  'stylers': [
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 20,
                      },
                  ],
              },
              {
                  'featureType': 'administrative',
                  'elementType': 'geometry.stroke',
                  'stylers': [
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 17,
                      },
                      {
                          'weight': 1.2,
                      },
                  ],
              },
              {
                  'featureType': 'landscape',
                  'elementType': 'geometry',
                  'stylers': [
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 20,
                      },
                  ],
              },
              {
                  'featureType': 'poi',
                  'elementType': 'geometry',
                  'stylers': [
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 21,
                      },
                  ],
              },
              {
                  'featureType': 'road.highway',
                  'elementType': 'geometry.fill',
                  'stylers': [
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 17,
                      },
                  ],
              },
              {
                  'featureType': 'road.highway',
                  'elementType': 'geometry.stroke',
                  'stylers': [
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 29,
                      },
                      {
                          'weight': 0.2,
                      },
                  ],
              },
              {
                  'featureType': 'road.arterial',
                  'elementType': 'geometry',
                  'stylers': [
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 18,
                      },
                  ],
              },
              {
                  'featureType': 'road.local',
                  'elementType': 'geometry',
                  'stylers': [
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 16,
                      },
                  ],
              },
              {
                  'featureType': 'transit',
                  'elementType': 'geometry',
                  'stylers': [
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 19,
                      },
                  ],
              },
              {
                  'featureType': 'water',
                  'elementType': 'geometry',
                  'stylers': [
                      {
                          'color': '#000000',
                      },
                      {
                          'lightness': 17,
                      },
                  ],
              },
          ],
        };

        var mapElement = document.getElementById('map');
        var map = new google.maps.Map(mapElement, mapOptions);
        let marker ='';
        let langCookie = Cookies.get('pll_language');

        if (langCookie == 'lu' || langCookie == 'de'){
             marker = new google.maps.Marker({
                position: point,
                icon: '/wp-content/themes/cinqfontaines/resources/assets/images/marker.svg',
              });
        } else {
            marker = new google.maps.Marker({
                position: point,
                icon: '/wp-content/themes/cinqfontaines/resources/assets/images/markerfr.png',
              });
        }

        marker.setMap(map);
      }
      initMap();


  }



// WEBPACK FOOTER //
// ./scripts/modules/map.js